export const features = {
    mediaInfo: false,
}
